export default "__VITE_ASSET__D6OaG_QC__"